/** Canonical challenge type consumed by `ChallengeTypeTag`. */
export type ChallengeType = 'new' | 'review' | 'combo';

/** Origin of a practice session shown by `PracticeOriginLabel`. */
export type PracticeOrigin = 'student' | 'tutor';

/**
 * Maps the raw content type coming from the API (e.g. "NEW", "REINFORCEMENT",
 * "COMBO") to the canonical challenge type consumed by `ChallengeTypeTag`.
 *
 * This is the single source of truth for the mapping so the practice view and
 * the student recommendations always render the same tag for the same session.
 */
export function mapContentTypeToChallenge(contentType?: string): ChallengeType {
  const typeMap: Record<string, ChallengeType> = {
    NEW: 'new',
    REINFORCEMENT: 'review',
    COMBO: 'combo',
  };

  if (!contentType) return 'new';

  return typeMap[contentType] ?? 'new';
}

/**
 * Maps the raw session type coming from the API (e.g. "NEW", "PRACTICE",
 * "STUDENT") to the practice origin shown on the recommendation cards:
 * student-created sessions render "Created by you", everything else renders
 * "From your tutor".
 */
export function mapSessionTypeToOrigin(sessionType?: string): PracticeOrigin {
  return sessionType === 'STUDENT' ? 'student' : 'tutor';
}
